import { mobileMenu, faqManager, initScrollAnimations, trackPageView, config } from '../lib';

/**
 * Initialize the akashic reading page
 */
export function initAkashicPage(): void {
  console.log('Initializing akashic reading page');

  // Initialize shared utilities
  mobileMenu.init();
  faqManager.init();
  initScrollAnimations();
  trackPageView();

  // Initialize contact form if present
  initContactForm();
}

function initContactForm(): void {
  const form = document.getElementById('contact-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formEl = form as HTMLFormElement;
    const formData = new FormData(formEl);
    const data = Object.fromEntries(formData.entries()) as Record<string, string>;

    // Basic validation
    if (!data.name || !data.email || !data.phone) {
      alert('Please fill in all required fields');
      return;
    }

    // Build WhatsApp message
    const message = `🙏 *Akashic Records Consultation Request*\n\n` +
      `📋 *Contact Details*\n` +
      `• Name: ${data.name}\n` +
      `• Email: ${data.email}\n` +
      `• Phone: ${data.phone}\n\n` +
      `💬 *Message*\n` +
      `${data.message || 'N/A'}\n\n` +
      `---\n` +
      `📍 Sent from: Akashic Reading Page`;

    const encodedMessage = encodeURIComponent(message);
    const url = `${config.whatsappBaseUrl}?phone=${config.phoneNumber}&text=${encodedMessage}`;
    window.open(url, '_blank');
  });
}

// Auto-initialize
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initAkashicPage);
}
